import { AIRA_REDUCER_DOMAIN } from "./constants";
import { fromJS } from 'immutable';

export const selectAskAiraDomain = (state) => state.get(AIRA_REDUCER_DOMAIN, fromJS({}));

